var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-48 w-full rounded animated-background"})
}
var staticRenderFns = []

export { render, staticRenderFns }